import { Navigate } from 'react-router-dom';
import { useBreakpoint } from '@/design-system/hooks/useBreakpoint';
import { useDataStore } from '@/stores/data-store';
import { useBootstrapStore } from '@/hooks/useBootstrap';
import { MobileLayout } from './MobileLayout';
import { DesktopLayout } from './DesktopLayout';

export function AppShell() {
  const { isMobile } = useBreakpoint();
  const foyer = useDataStore((s) => s.foyer);
  const mode = useBootstrapStore((s) => s.mode);

  if (foyer === null) {
    // Cloud session without foyer → skip welcome, go straight to foyer choice.
    // Local / no session → welcome (PRD Module 9 §2.1).
    const target = mode === 'cloud' ? '/choix-foyer' : '/welcome';
    return <Navigate to={target} replace />;
  }

  return isMobile ? <MobileLayout /> : <DesktopLayout />;
}
